<template>
  <div class="choose-price setMobileHeroNavigation">
    <template>
      <h1>Selecione uma <br /> faixa de preço</h1>
      <div class="icons-tv largeContainer">
        <img :class="{ inactiveFamily: !family.crystal }" src="../../assets/price-icon-crystal.png" alt="">
        <img :class="{ inactiveFamily: !family.qled }" src="../../assets/price-icon-qled.png" alt="">
        <img :class="{ inactiveFamily: !family.lifestyle }" src="../../assets/price-icon-lifestyle.png" alt="">
        <img :class="{ inactiveFamily: !family.neoqled }" src="../../assets/price-icon-neo-qled.png" alt="">
        <img :class="{ inactiveFamily: !family.neoqled8k }" src="../../assets/price-icon-neo-qled-8k.png" alt="">
      </div>
      <div class="range-slider largeContainer">
        <RangeSlider :min="min" :max="max" @selectPrice="onSelectPrice" />
      </div>
      
    </template>
  </div>
</template>

<script>
import { getFamilies } from "../../utils/dataHandler";
import RangeSlider from "../RangeSlider.vue";

function getFamilyToggles(userChoices) {
  const family = getFamilies({
    passion: userChoices.passionSelected,
    feature: userChoices.featureSelected,
    size: userChoices.inchSelected,
    price: userChoices.priceSelected
  });

  return {
    crystal: family.includes("Crystal UHD"),
    qled: family.includes("QLED"),
    lifestyle: family.includes("Lifestyle"),
    neoqled: family.includes("Neo QLED"),
    neoqled8k: family.includes("Neo QLED 8K"),
  }
}

export default {
  name: "ChoosePrice",
  components: { RangeSlider },
  props: ["sendAnalytics", "userChoices"],
  data() {
    return {
      min: parseInt(sessionStorage.getItem('min')),
      max: parseInt(sessionStorage.getItem('max')),
      family: {
        ...getFamilyToggles(this.userChoices)
      }
    };
  },
  watch: {
    userChoices(val) {
      this.family = getFamilyToggles(val);
    }
  },
  mounted() {
    this.onSelectPrice(this.max);
  },
  methods: {
    onSelectPrice(selectPrice) {
      this.$emit('clickSelectPrice', selectPrice.toString());
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/main.scss";

.inactiveFamily {
  opacity: 0.4;
}

.choose-price {
  display: flex;

  width: 100%;
  // min-height: 730px;
  min-height: 730px;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  background-color: $color-gray;

  h1 {
    font-family: $font-family-title;
    font-size: 2.5rem;
    line-height: 3rem;

    text-align: center;

    max-width: 700px;

    padding: 2% 0 0 20%;
  }

  .range-slider,
  .icons-tv {
    display: flex;
    justify-content: center;
    align-items: center;

    max-width: 1000px;

    flex-wrap: wrap;

    padding: 65px 0 0 20%;
    gap: 0rem;
  }

  .largeContainer {
    max-width: 100%;
    // margin: 65px -275px 0 0;
  }

  .icons-tv {
    max-width: 100%;
  }
}

@media (max-width: 1218px) {
  .choose-price {
    .range-slider,
    .icons-tv {
      max-width: 1000px;
    }
  }
}

@media (max-width: 900px) {
  .choose-price {
    padding-bottom: 10%;
    .range-slider {
      max-width: 500px;
    }
  }
}

@media (max-width: $bp-mobile) {
  .choose-price {
    padding: 20% 0 10% 0;
    // min-height: 70px;
    min-height: 530px;

    h1 {
      padding: 0;
      max-width: 500px;
      margin: 0 $margin-side-title-mobile;
      font-size: 2rem;
      line-height: 2.3rem;
    }

    .icons-tv {
      display: none;
    }

    .range-slider {
      max-width: 100%;
      // padding: 40px 0 0 0;
      padding: 120px 0 0 0;
    }
  }
}

@media (max-width: 572px) {
  .choose-price {
    padding: 25% 0 10% 0;

    h1 {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
}
</style>
